import { apiClient } from './client';

/**
 * 링크 미리보기 API — chat-server `GET /api/v1/chat/link-preview` 와 1:1.
 * (chat-link-preview — 2026-06-30)
 *
 * 서버가 URL 을 대신 열어 OG 메타(제목·설명·썸네일)를 파싱해 반환. 동일 URL 의 중복 요청은
 * 모듈 캐시로 dedupe(렌더 반복·여러 메시지가 같은 링크). 실패는 null → 컴포넌트가 도메인 카드 폴백.
 */
export interface LinkPreview {
  url: string;
  host: string | null;
  title: string | null;
  description: string | null;
  image: string | null;
  siteName: string | null;
}

const cache = new Map<string, Promise<LinkPreview | null>>();

export function getLinkPreview(url: string): Promise<LinkPreview | null> {
  const hit = cache.get(url);
  if (hit) return hit;
  const p = apiClient
    .get<LinkPreview>('/chat/link-preview', { params: { url } })
    .then((res) => res.data)
    .catch(() => null);
  cache.set(url, p);
  return p;
}
